/* 封装ajax请求函数
  返回值：promise对象（异步返回的数据是：res.data）
*/
import axios from '../config/http'
export default function ajax (url, data = {}, type = 'GET') {
  return new Promise((resolve, reject) => {
    // 执行异步ajax请求
    let promise
    if (type === 'GET') {
      let dataStr = ''
      if (data) {
        // 有数据
        Object.keys(data).forEach(key => {
          dataStr += key + '=' + data[key] + '&'
        })
        if (dataStr) {
          dataStr = dataStr.substr(0, dataStr.length - 1)
          url = url + '?' + dataStr
        }
      }
      promise = axios.get(url)
    } else {
      promise = axios.post(url, data)
    }
    // 成功调用resolve
    promise.then(res => {
      resolve(res.data)
    }).catch(err => {
      // 失败调用reject
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/ajax.js